import { render } from "./UsersTable.vue?vue&type=template&id=a930ef92&scoped=true&lang=pug"
import script from "./UsersTable.vue?vue&type=script&lang=ts"
export * from "./UsersTable.vue?vue&type=script&lang=ts"

import "./UsersTable.vue?vue&type=style&index=0&id=a930ef92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a930ef92"

export default script